import { useEffect, useState } from 'react';
import { useModal } from '@/contexts/ModalContext';
import { supabase } from '@/integrations/supabase/client';

export const useLinkedInTokenMonitor = () => {
  const { openModal } = useModal();
  const [isTokenExpired, setIsTokenExpired] = useState(false);
  
  const initiateReauthorization = async () => {
    try {
      const { data, error } = await supabase.functions.invoke('linkedin-auth', {
        body: { action: 'initiate' }
      });
      
      if (error) throw error;
      
      // Redirect to LinkedIn authorization URL
      window.location.href = data.authorizationUrl;
    } catch (error) {
      console.error('Failed to initiate LinkedIn reauthorization:', error);
    }
  };

  const checkTokenExpiration = async () => {
    try {
      const { data, error } = await supabase.functions.invoke('check-linkedin-token-expiry');
      
      if (error) throw error;
            
      if (data.isInitialSetup) {
        openModal({
          type: 'linkedin-reauth',
          isInitialSetup: true,
          onReauthorize: initiateReauthorization
        });
        return;
      }

      setIsTokenExpired(data.isExpiredOrExpiring);
      if (data.isExpiredOrExpiring) {
        openModal({
          type: 'linkedin-reauth',
          isInitialSetup: false,
          onReauthorize: initiateReauthorization
        });
      }
    } catch (error) {
      console.error('Error checking LinkedIn token expiration:', error);
    }
  };

  useEffect(() => {
    // Delay the check to allow initial render
    const timer = setTimeout(checkTokenExpiration, 0);
    return () => clearTimeout(timer);
  }, []);

  return {
    isTokenExpired,
    initiateReauthorization
  };
};